'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var loader = require('./loader-f28c8bde.js');
var overlay = require('./overlay-878554b6.js');

var Container = styled__default.div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 191px 0 239px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 191px 0 239px;\n"])));
var HqOTableLoader = function (_a) {
    var isLoading = _a.isLoading, className = _a.className;
    if (!isLoading) {
        return null;
    }
    return (React__default.createElement(Container, { "data-testid": "hqo-table-loader", className: className + "-loader" },
        React__default.createElement(overlay.Overlay, null,
            React__default.createElement(loader.Loader, { size: 50 }))));
};
var templateObject_1;

exports.HqOTableLoader = HqOTableLoader;
